import { render } from "./SReCaptcha.vue?vue&type=template&id=64ec0ae7&scoped=true"
import script from "./SReCaptcha.vue?vue&type=script&lang=js"
export * from "./SReCaptcha.vue?vue&type=script&lang=js"

import "./SReCaptcha.vue?vue&type=style&index=0&id=64ec0ae7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ec0ae7"]])

export default __exports__